import React from "react"
import { withStyles } from "@material-ui/core/styles"
import classNames from "classnames"

const styles = (theme) => ({
    a: {
        color: theme.palette.secondary.main,
        textDecoration: "none",
        transition: "color 0.2s linear",
        "&:hover": {
            color: theme.palette.primary.main,
            textDecoration: "none",
        },
    },
    inverted: {
        color: theme.palette.primary.main,
        "&:hover": {
            color: theme.palette.secondary.main,
        },
    },
})

const aMd = ({ classes, children, href, inverted, title, component, ...props }) => {
    const Component = component ?? "a";

    return <Component {...props} className={classNames(classes.a, {
        [classes.inverted]: inverted,
    })} href={href} title={title}>{children}</Component>
}

export const AMd = withStyles(styles)(aMd)